import { render, staticRenderFns } from "./SortByDropdown.vue?vue&type=template&id=33d90342&scoped=true&"
import script from "./SortByDropdown.vue?vue&type=script&lang=js&"
export * from "./SortByDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SortByDropdown.vue?vue&type=style&index=0&id=33d90342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d90342",
  null
  
)

export default component.exports